import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconEmailAltComponent } from "./med-icon-email-alt.component";

@NgModule({
  declarations: [
    MedIconEmailAltComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconEmailAltComponent,
  ],
})
export class MedIconEmailAltModule { }
